export default __webpack_public_path__ + "static/media/Dienstleister.ff38c459.svg";